import { Heading } from '@lmc/ui-kit'
import type { ComponentProps, FC } from 'react'
import styled from 'styled-components'

const StyledHeading = styled(Heading)`
  color: ${({ theme }) => theme.palette.darkpurple};
  font-weight: 700;
  font-size: 54px;
  max-width: 800px;
  font-family: gilroy;
  line-height: 59px;
`

export const OnboardingHeading: FC<ComponentProps<typeof Heading>> = (
  props
) => <StyledHeading {...props} />
